const base = {
    get() {
        return {
            url : "https://kq.xinjiese.cn/springbootk0ie3hg5/",
            name: "springbootk0ie3hg5",
            // 退出到首页链接
            indexUrl: 'https://kq.xinjiese.cn/springbootk0ie3hg5/front/h5/index.html'
        };
    },
    getProjectName(){
        return {
            projectName: "青创考勤系统后台"
        } 
    }
}
export default base
